import React, { useState } from 'react';
import { Button, TextField, Container, Typography, Box, IconButton, InputAdornment, Alert, Link } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import './login_mapRight.css';

function LoginMapRight({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    
    const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    });

    if (response.ok) {
      const data = await response.json();
      localStorage.setItem('token', data.token);
      onLogin(data.token);
      // console.log('Login successful with token:', data.token);
    } else {
      setErrorMessage('Invalid credentials. Please try again.');
    }
  };

  const handleLoginClick = () => {
    setShowLoginForm(true);
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  if (!showLoginForm) {
    return (
      <div className="main-container">
        <div className="title-container">
          <Typography component="h1" variant="h3" align='center'>
            Welcome!
          </Typography>
          <Typography variant="subtitle1" align='center' sx={{ mt: 2 }}>
            You need authorization to access this map.
          </Typography>
        </div>
        <div className="button-container">
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleLoginClick}
            sx={{
              mt: 4,
              borderRadius: '10px',
              padding: '2px 5px',
              transition: 'all 0.3s ease-in-out',
              ':hover': {
                transform: 'scale(1.05)',
              }
            }}
          >
            Login
          </Button>
        </div>
        <div className="contact-container">
          <Typography variant="body2" align='center' sx={{ mt: 3 }}>
            Don’t have credentials?
            <br />
            <Link href="mailto:lcirujan@pa.uc3m.es?subject=Request%20for%20Access%20to%20the%20Map&body=Hello,%0D%0A%0D%0AI%20would%20like%20to%20request%20credentials%20to%20access%20the%20restricted%20map%20section.%0D%0APlease%20let%20me%20know%20how%20I%20can%20proceed.%0D%0A%0D%0AThank%20you%20in%20advance!%0D%0ABest%20regards,%0D%0A[Your%20Name]" underline="hover"
            sx={{ textDecoration: 'underline' }}
            >
              Contact support
            </Link>
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '20px',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
          borderRadius: '10px',
          backgroundColor: '#fff'
        }}
      >
        <AccountCircleOutlinedIcon sx={{ fontSize: 64, color: '#3f51b5' }} />
        <Typography component="h3" variant="h5" sx={{ mt: 1.5 }}>
        </Typography>
        
        {errorMessage && (
          <Alert severity="error" sx={{ height:'80%', width: '100%', mt: 0, mb:0 }}>
            {errorMessage}
          </Alert>
        )}
        
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 0 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="username"
            label="Username"
            name="username"
            autoComplete="username"
            autoFocus
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            variant="outlined"
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type={showPassword ? 'text' : 'password'}
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            variant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{
              mt: 1,
              mb: 1,
              width: '100%', 
              align: 'center',  // Alineación vertical
              padding: '8px 16px',  // Ajuste del padding
              borderRadius: '5px',  // Ajuste del borde redondeado
              background: 'linear-gradient(135deg, #3f51b5, #5a67d8)',  // Gradiente en el fondo
              color: 'white',
              fontSize: '0.9rem',  // Tamaño de fuente ajustado
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',  // Sombra predeterminada
              transition: 'all 0.3s ease',  // Transición suave
              ':hover': {
                background: 'linear-gradient(135deg, #303f9f, #4a55d4)',  // Color más intenso en hover
                transform: 'translateY(-2px)',  // Movimiento en hover
                boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.3)',  // Sombra más fuerte en hover
              }
            }}
          >
            Login
          </Button>
          <Typography variant="body2" align='center' sx={{ mt: 3 }}>
            Don’t have credentials? {''}
            <Link href="mailto:lcirujan@pa.uc3m.es?subject=Request%20for%20Access%20to%20the%20Map&body=Hello,%0D%0A%0D%0AI%20would%20like%20to%20request%20credentials%20to%20access%20the%20restricted%20map%20section.%0D%0APlease%20let%20me%20know%20how%20I%20can%20proceed.%0D%0A%0D%0AThank%20you%20in%20advance!%0D%0ABest%20regards,%0D%0A[Your%20Name]" underline="hover"
            sx={{ textDecoration: 'underline' }}
            >
              Contact support
            </Link>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
}

export default LoginMapRight;
